import { Container } from "../../components";

export const NotFound = () => <Container header titulo="La página no existe o su acceso no está autorizado :/" />;
